import { Content } from '@radix-ui/react-accordion';
import React from 'react';

import { cn } from '@/services/utils';

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof Content>,
  React.ComponentPropsWithoutRef<typeof Content>
>(({ className, children, ...props }, ref) => (
    <Content
        ref={ref}
        className={cn(
            'tw-overflow-hidden lg-font-dynamic tw-transition-all data-[state=closed]:tw-animate-accordion-up data-[state=open]:tw-animate-accordion-down',
            className
        )}
        {...props}
    >
        {children}
    </Content>
));

AccordionContent.displayName = Content.displayName;

export { AccordionContent };
